// StageDetailsAndStatistics.tsx
import React, { useState } from 'react';
import { Button, Collapse, Divider } from '@rio-cloud/rio-uikit';
import { FormattedMessage } from 'react-intl';
import { Stage } from '~/api/models/stage';
import { openInNewTab } from '~/features/base/utils/openInNewTab';
import { GROUPS_PATH } from '~/features/base/constants/routes';
import { GroupPropertiesContainer } from '~/features/groups/components/GroupPropertiesContainer';
import { useFetchVehicleGroupsQuery } from '~/api/vehicleGroup/VehicleGroup.api';
import { useGetStageStatisticsQuery } from '~/api/campaignStatistics/CampaignStatistics.api';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StageStatisticsBody from '~/features/campaigns/components/StageStatisticsBody';

interface StageDetailsAndStatisticsProps {
    stage: Stage;
}

const StageDetailsAndStatistics: React.FC<StageDetailsAndStatisticsProps> = ({ stage }) => {
    const [showGroupDetails, setShowGroupDetails] = useState(false);
    const { data: groups } = useFetchVehicleGroupsQuery({});
    const { data: stageStatistics, isLoading: stageLoading } = useGetStageStatisticsQuery(
        stage.id!,
        { skip: !stage.id }
    );


    return (
        <>
            <div className={'display-flex align-items-center'}>
                <span className={' text-bold h3'}>
                    <FormattedMessage id='intl-msg:detailsAndStatistics'/>
                </span>
            </div>
            <Divider/>
            <div className='display-flex flex-row gap-25'>
                <div className='display-flex flex-column gap-20 width-100pct'>
                    <div className='display-flex flex-row gap-25 align-items-center'>

                        <div className='display-flex flex-column'>
                            <h6><FormattedMessage id='intl-msg:groupAssigned'/>:</h6>
                            <div className='display-flex align-items-center gap-10'>
                                <div
                                    className='badge badge-info padding-5'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => openInNewTab(`/#${GROUPS_PATH}/${stage.vehicleGroup}`)}
                                >
                                    {stage.vehicleGroup}
                                </div>
                                <div>
                                    <Button
                                        className='btn btn-link padding-0'
                                        onClick={() => setShowGroupDetails(!showGroupDetails)}
                                    >
                                        <span className={''}><FormattedMessage id={'intl-msg:moreDetails'}/></span>...
                                        <i className={`rioglyph margin-left-5 rioglyph-chevron-${showGroupDetails ? 'up' : 'down'}`}/>
                                    </Button>
                                </div>

                            </div>

                        </div>

                    </div>

                    <Collapse open={showGroupDetails} onExited={() => setShowGroupDetails(false)}>
                        <div className='card'>
                            <div className='card-body'>
                                <GroupPropertiesContainer
                                    groupDesc={groups?.find(group => group.name === stage.vehicleGroup)}
                                    groupName={stage.vehicleGroup}
                                />
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
            <div className='width-100pct '>
                {stageStatistics || stageLoading ? (
                    <StatsWidgets>
                        <StatsWidget>
                            <StatsWidget.Body>
                                <StageStatisticsBody stageLoading={stageLoading}
                                                     statistics={stageStatistics?.stageStatistics}/>
                            </StatsWidget.Body>
                        </StatsWidget>
                    </StatsWidgets>
                ) : (
                    <div className='display-flex justify-content-center align-items-center height-200'>
                        <span className='text-muted'>No statistics available</span>
                    </div>
                )}
            </div>
        </>
    );
};

export default StageDetailsAndStatistics;
